export const roundMoney = (n = null) => {
  if (!n) {
    return n
  }
  const s = n.toString().split('.')
  let beforeDecimal = s[0] // This is the number BEFORE the decimal.
  let afterDecimal = '.00' // This is the number AFTER the decimal.

  if (beforeDecimal.length < 3) {
    // 0.33 => 1; 1.21 => 2; 11.33 => 12;
    beforeDecimal = Math.ceil(n)
  } else if (beforeDecimal.length < 4) {
    // 111.44 => 120;
    beforeDecimal = Math.ceil(n / 10) * 10
  } else if (beforeDecimal.length < 6) {
    // 1133.33 => 1200; 13333 => 13400;
    beforeDecimal = Math.ceil(n / 100) * 100
  } else if (beforeDecimal.length >= 6) {
    // 133111 => 134000; 1101101.10 => 1102000;
    beforeDecimal = Math.ceil(n / 1000) * 1000
  }
  return +(beforeDecimal + afterDecimal)
}
